export const settings = {
  filialeusers: {
    modal: {
      title: 'Sélection d\'un utilisateur'
    },
    fiche: {
      title: {
        edit_title: "Fiche de l'utilisateur {{name}}",
        new_title: "Création d'un nouvel utilisateur",
        view_title:
          "Fiche du profil d'utilisateur {{name}} (Lecture seul - Modification 4Yeux en attente)",
        group_users: "Membre de",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        history: 'Historique',
        reinitialise: 'Réinitialiser TOTP',
        reinitialise_pwd: 'Réinitialiser Mot de passe',
        message_confirm_pwd: 'Voulez-vous réinitialiser le mot de Passe'
      },
      placeholder: "Sélection d'un utilisateur",
      login: 'Login',
      email: 'Email',
      name: 'Nom',
      prenom: 'Prénom',
      langue: 'Langue',
      smart: 'Smart-tags',
      nPhone: 'Téléphone',
      nFax: 'Fax',
      nMobile: 'Mobile',
    },
    table: {
      header: {
        title: 'Liste des utilisateurs',
        new_user: 'Nouveau',
        list_pouvoir: 'Liste pouvoir utilisateur',
        detail_pouvoir: 'Liste détaillée pouvoir',
        title_button: "Impression Synthèse Pouvoirs"
      },
      columns: {
        user_entity_state: 'Etat user entité',
        user_state: 'Etat',
        login: 'Login',
        name: 'Nom',
        prenom: 'Prénom',
        email: 'Email',
        nMobile: 'N° Mobile',
        date: 'Date de modification',
      },
    },
  },
  groupusers: {
    fiche: {
      title: {
        edit_title: 'Fiche du profil utilisateur {{name}}',
        new_title: "Création d'un profil utilisateur",
        view_title:
          "Fiche du profil d'utilisateur {{name}} (Lecture seul - Modification 4Yeux en attente)",
        members: 'Membres',
        authorizations: 'Autorisations',
        flow: 'Flux',
        accounting: 'Comptabilité',
        accounting_export: 'Export comptable',
        setting: 'Paramétrage',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        history: 'Historique',
        create: 'Créer',
      },
      champ_titles: {
        code: 'Code',
        state: 'Etat',
        name: 'Nom',
        users: 'Utilisateurs',
        users_grp: "Profils d'utilisateurs",
        smart_tag: 'SmartTags'
      },
      columns: {
        login: 'Login',
        name: 'Nom',
        first_name: 'Prénom',
        state: 'Etat',
        flow: 'Flux',
        readings: 'Relevés',
        repository: 'Référentiel',
        settings: 'Paramétrage',
        treatments: 'Traitements',
        accounting: 'Comptabilité',
        accounting_export: 'Export comptable',
        rates_and_currencies: 'Taux et Devises'
      },

    },
    modal: {
      title: 'Sélectionner un utilisateur',
      buttons: {
        add: 'Ajouter',
        close: 'Annuler',
      },
    },
    table: {
      header: {
        title: "Liste des profils d'utilisateurs",
        new_groupuser: 'Nouveau',
        synthesis: 'Synthèse profils utilisateurs',
        export_droit: "Export Excel des droits",

      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        date: 'Date de modification',
      },
    },
  },
  SmartTags: {
    fiche: {
      title: {
        edit_title: 'Fiche du Smart Tag {{code}}',
        create: "Création d'un nouveau Smart Tag",
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        archive: 'Archiver'
      },
      champ_titles: {
        users: 'Utilisateurs',
        users_grp: "Profils d'utilisateurs",
      },
    },
    table: {
      header: {
        title: 'Liste des SmartTags',
      },
      columns: {
        code: 'Code',
      },
    },
  },
  FourYeux: {
    fiche: {
      title: {
        default: 'Demande validée',
        creation: 'Demande de création',
        modification: 'Demande de modification',
        suppression: 'Demande de suppression',
        revoke: 'Annuler la demande'
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider la demande',
        refuse: 'Refuser la demande',
        create: 'Créer',
        revoke: 'Annuler la demande',
        alert: 'Veuillez visualiser le document RIB avant de valider'
      },
      champ_titles: {
        initiale: 'Fiche initiale',
        demande: 'Fiche modifiée'
      },
    },
    table: {
      header: {
        title: '4Yeux validation',
      },
      columns: {
        code: 'Code',
        state: 'Etat',
        libelle: 'Libellé',
        date: 'Date de modification',
        demand_number: '#',
        denomination: 'Dénomination',
        demand_type: 'Type de demande',
        short_name: 'Nom (long)',
        demandeur: 'Demandeur',
        demand_date: 'Date de demande',
        validator: 'Validateur',
        validation_date: 'Validation / Refus',
      },
    },
  },
  pouvoirSignature: {
    table: {
      header: {
        title: 'Liste des pouvoirs de signature',
        synthese: 'Synthèse des pouvoirs'
      },
    },
    fiche: {
      title_form: "Fiche du pouvoir",
      title_create: "Création d'un nouveau pouvoir de signataire",
      code: 'Code',
      code_placeholder: 'Code du pouvoir de signature',
      name: 'Nom',
      name_placeholder: 'Nom du pouvoir de signature',
      type: 'Type',
      etat: 'Etat',
      flux: 'Flux',
      devise: 'Devise',
      titleTab1: 'Collège de signataires',
      titleTab2: 'Liste des sociétés membres',
      titleTab3: 'Liste des comptes membres',
      signatoryType: "Type Signataire",
      table_colleg_signature: {
        pouvoir_descr: "Description",
        coll1: 'Collège 1',
        coll2: 'Collège 2',
        niveau: 'Niveau',
        type: 'Type de seuil',
        seuil: 'Seuil inf',
        seuil_sup: 'Seuil sup.',
        ordre: 'Ordre',
      },
      table_societe_member: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
      },
      table_compte_member: {
        code: 'Code',
        name: 'Nom',
        iban: 'IBAN',
        state: 'Etat',
      },
      modalSignature: {
        title: 'Ajouter des collèges de signataires',
        add: 'Ajouter',
        cancel: 'Annuler',
        pouvoir_descr: "Descriptions de pouvoir",
        niv_signature: 'Niveau de signature',
        college_1: 'Collège 1',
        college_2: 'Collège 2',
        college: 'Collège {{nb}}',
        ordre: 'Ordre',
        type_seuil: 'Type de seuil',
        seuil_inf: 'Seuil inférieur',
        seuil_supp: 'Seuil supérieur',
        error_colleg1: "Veuillez choisir un collège 1"
      },
      modal_company_member: {
        title: 'Sélection de sociétés',
      },
      modal_compte_member: {
        title: 'Sélection de comptes bancaires',
      },
      buttons: {
        back: 'Annuler',
      },
    },
  },
  college: {
    table: {
      header: {
        title: 'Liste des collèges de signataire',
        synthese: 'Synthèse des collèges'
      },
      columns: {
        state: 'Etat',
        code: 'Code',
        name: 'Nom',
        electronic_signature: 'Signature éléctronique',
        date: 'Date de modification',
      },
    },
    fiche: {
      title: {
        edit_title: 'Fiche du collège {{code}}',
        new_title: "Création d'un nouveau collège de signataire",
        signatories: 'Signataires',
      },
      buttons: {
        back: 'Annuler',
        save: 'Valider',
        history: 'Historique',
      },
      champ_titles: {
        code: 'Code',
        name: 'Nom',
        state: 'Etat',
        signature: 'Signature',
      },
      columns: {
        state: 'Etat',
        first_name: 'Prénom',
        name: 'Nom',
        login: 'Login',
      },
    },
    modal: {
      title: 'Sélectionner un utilisateur',
      buttons: {
        add: 'Ajouter',
        close: 'Annuler',
      },
    },
    history: {
      title: {
        edit_title: 'Historique des modifications de la fiche : {{time}}'
      },
      columns: {
        state: 'Etat 4Yeux',
        timestamp_creation: 'Date création',
        update_timestamp: 'Date validation',
        login_creation: 'Création',
        login_validation: 'Validation'

      },
      buttons: {
        back: 'Annuler'
      }

    }
  },
};
